import { useTranslation } from "react-i18next";
import { Box, Chip, Tooltip } from "@mui/material";

const CellValue = ({ value }: { value: string | number | boolean | string[] | number[] }) => {
  const { t } = useTranslation("goHire", { keyPrefix: "components.compareCandidatesModal" });

  if (Array.isArray(value)) {
    return (
      <Box sx={{ display: "flex", gap: "4px", justifyContent: "center" }}>
        {value.slice(0, 1).map((v) => (
          <Tooltip title={v} placement="top-end" arrow>
            <Chip key={v} label={v} sx={styles.chipValue} />
          </Tooltip>
        ))}
        {value.length > 1 && (
          <Tooltip title={value.slice(1).join(", ")} placement="top-end" arrow>
            <Chip label={`+${value.length - 1}`} sx={styles.chipValue} />
          </Tooltip>
        )}
      </Box>
    );
  }
  if (typeof value === "boolean") return <Box sx={styles.booleanValueCell}>{value ? t("yes") : t("no")}</Box>;
  return <Box sx={styles.valueCell}>{value}</Box>;
};

export default CellValue;

const styles = {
  valueCell: {
    fontFamily: "Montserrat",
    color: "var(--Gray-600, #475467)",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
    textAlign: "center",
  },
  booleanValueCell: {
    fontFamily: "Montserrat",
    color: "var(--Gray-900, #101828)",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
    textAlign: "center",
  },
  chipValue: {
    fontFamily: "Montserrat",
    color: "var(--Gray-700, #344054)",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "18px",
    padding: "2px 8px",
    borderRadius: "16px",
    border: "1px solid var(--Gray-200, #E4E7EC)",
    background: "var(--Gray-50, #F9FAFB)",
    height: "fit-content",
    maxWidth: "120px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    "& .MuiChip-label": {
      padding: 0,
    },
  },
};
